import { render, staticRenderFns } from "./userStatistics.vue?vue&type=template&id=a4943e9e&scoped=true&"
import script from "./userStatistics.vue?vue&type=script&lang=js&"
export * from "./userStatistics.vue?vue&type=script&lang=js&"
import style0 from "./userStatistics.vue?vue&type=style&index=0&id=a4943e9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4943e9e",
  null
  
)

export default component.exports